import type { ReactNode } from 'react';
import Audit from './pages/Audit';
import CaseDetail from './pages/CaseDetail';
import Dashboard from './pages/Dashboard';
import Evidence from './pages/Evidence';
import ForensicReq from './pages/ForensicReq';
import Geo from './pages/Geo';
import Network from './pages/Network';
import Report from './pages/Report';
import Roles from './pages/Roles';
import Substances from './pages/Substances';

export interface RouteDef {
  path: string;
  element: ReactNode;
}

export const routes: RouteDef[] = [
  { path: '/', element: <Dashboard /> },
  { path: '/case', element: <CaseDetail /> },
  { path: '/relation', element: <Network /> },
  { path: '/geo', element: <Geo /> },
  { path: '/evidence', element: <Evidence /> },
  { path: '/substance', element: <Substances /> },
  { path: '/roles', element: <Roles /> },
  { path: '/audit', element: <Audit /> },
  { path: '/forensicreq', element: <ForensicReq /> },
  { path: '/report', element: <Report /> },
];
